var _path, _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetbankingTheme2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49148 17.5936L26.0001 6.89038L43.5088 17.5936H8.49148Z",
    fill: "#9EA0FF",
    stroke: "#5A5CE7",
    strokeWidth: 2.71333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7832,
    y: 20.4668,
    width: 3.03333,
    height: 10.0241,
    rx: 1.51667,
    fill: "#5A5CE7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4834,
    y: 20.4668,
    width: 3.03333,
    height: 10.0241,
    rx: 1.51667,
    fill: "#5A5CE7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 36.1826,
    y: 20.4668,
    width: 3.03333,
    height: 10.0241,
    rx: 1.51667,
    fill: "#5A5CE7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.01562,
    y: 32.6001,
    width: 35.5333,
    height: 3.08333,
    rx: 1.54167,
    fill: "#5A5CE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5301_15368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7012 21.875C42.1885 21.875 45.8262 18.2373 45.8262 13.75C45.8262 9.26269 42.1885 5.625 37.7012 5.625C33.2139 5.625 29.5762 9.26269 29.5762 13.75C29.5762 18.2373 33.2139 21.875 37.7012 21.875Z",
    fill: "white",
    stroke: "#5A5CE7",
    strokeWidth: 2.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7002 5.625C39.7325 7.84991 40.8874 10.7373 40.9502 13.75C40.8874 16.7627 39.7325 19.6501 37.7002 21.875C35.6679 19.6501 34.513 16.7627 34.4502 13.75C34.513 10.7373 35.6679 7.84991 37.7002 5.625V5.625Z",
    fill: "#9EA0FF",
    stroke: "#5A5CE7",
    strokeWidth: 2.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5762 13.75H45.8262",
    stroke: "#5A5CE7",
    strokeWidth: 2.46667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5301_15368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 19.5,
    fill: "white",
    transform: "translate(27.9512 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetbankingTheme2);
export default __webpack_public_path__ + "static/media/NetbankingTheme2.1a4d813b7ca23566247a1b2f8e41b726.svg";
export { ForwardRef as ReactComponent };